import { useEffect, useState } from 'react';
import { subscribeClientAccess } from '../utils/posSubscriptionUtil';

/**
 * Whether an administrator has disabled this client's till — live, so a till
 * re-opens by itself the moment a renewal is approved.
 *
 * `access` is `undefined` until the first answer, `null` for an open till, or
 * the stored record (`{ disabled: true, ... }`).
 *
 * A FAILED READ COUNTS AS OPEN. Shutting a paying club out of its own till
 * because of a network blip or a rules hiccup would be far worse than letting
 * a disabled one through for the length of that blip.
 *
 * @param {string} clientId
 * @returns {{access: object|null|undefined, disabled: boolean, loading: boolean}}
 */
export function useClientAccess(clientId) {
  const [access, setAccess] = useState(undefined);

  useEffect(() => {
    if (!clientId) {
      setAccess(null);
      return undefined;
    }
    setAccess(undefined);
    return subscribeClientAccess(clientId, setAccess, () => setAccess(null));
  }, [clientId]);

  return {
    access,
    disabled: access?.disabled === true,
    loading: access === undefined,
  };
}

export default useClientAccess;
